import React, {useLayoutEffect} from "react";
import {Tooltip} from "antd";
import {FileSearchOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {TableContainer, ActionButtons} from "./ResponsiveDataTable.styles";
import {useHistory} from "react-router-dom";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import {EmptyMessage} from "../../../_defaultComponents/EmptyMessage/EmptyMessage";

const TABLE_PREFIX = "poolTable";
const ResponsiveDataTable = ({data, loading, currentPage, setCurrentPage, dataCount}) => {
    const {t} = useTranslation(["pools"]);
    const history = useHistory();

    const onClickDetailButton = poolId => {
        window.open(`/pools/${poolId}`, "_blank");
    };
    const renderActionButtons = id => {
        const permisions = {
            show: true
        };
        return (
            <ActionButtons>
                {permisions.show && (
                    <Tooltip title={t("actions.detail", {ns: "common"})}>
                        <CustomButton
                            data-testid="poolDetailButton"
                            onClick={() => onClickDetailButton(id)}
                            icon={<FileSearchOutlined />}
                        ></CustomButton>
                    </Tooltip>
                )}
            </ActionButtons>
        );
    };

    return (
        <>
            <TableContainer
                className={TABLE_PREFIX}
                locale={{
                    emptyText: <EmptyMessage />
                }}
                pagination={{
                    total: dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setCurrentPage(page);
                    },
                    hideOnSinglePage: true,
                    showSizeChanger: false
                }}
                rowKey="_id"
                rowClassName="hello"
                dataSource={data}
                data-testid="poolDataTable"
                loading={loading}
            >
                <TableContainer.Column
                    title={t("actions.action", {ns: "common"})}
                    dataIndex="_id"
                    render={id => {
                        return (
                            <span
                                data-testid="poolActionButtons"
                                data-label={t("actions.action", {ns: "common"})}
                            >
                                {renderActionButtons(id)}
                            </span>
                        );
                    }}
                />
                <TableContainer.Column
                    dataIndex="name"
                    title={t("fields.poolRegion", {ns: "pools"})}
                    render={name => (
                        <span
                            data-testid="poolName"
                            data-label={`${t("fields.poolRegion", {ns: "pools"})}:`}
                        >
                            {name}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="city"
                    title={t("fields.city", {ns: "common"})}
                    render={city => (
                        <span
                            data-testid="poolCity"
                            data-label={`${t("fields.city", {ns: "common"})}:`}
                        >
                            {city?.capitalize()}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="companies"
                    title={t("fields.poolCompaniesCount", {ns: "pools"})}
                    render={companies => (
                        <span
                            data-testid="poolCompaniesCount"
                            data-label={`${t("fields.poolCompaniesCount", {ns: "pools"})}:`}
                        >
                            {companies ? companies.length : "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="subCompanies"
                    title={t("fields.poolSubCompaniesCount", {ns: "pools"})}
                    render={subCompanies => (
                        <span
                            data-testid="poolSubCompaniesCount"
                            data-label={`${t("fields.poolSubCompaniesCount", {ns: "pools"})}:`}
                        >
                            {subCompanies ? subCompanies.length : "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="couriers"
                    title={t("fields.poolCouriersCount", {ns: "pools"})}
                    render={couriers => (
                        <span
                            data-testid="poolCouriersCount"
                            data-label={`${t("fields.poolCouriersCount", {ns: "pools"})}:`}
                        >
                            {couriers ? couriers.length : "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="integrationType"
                    title={t("filters.integrationType", {ns: "common"})}
                    render={integrationType => (
                        <span
                            data-testid="poolIntegrationType"
                            data-label={t("filters.integrationType", {ns: "common"})}
                        >
                            {integrationType === "pool"
                                ? "Havuz"
                                : integrationType === "dedicated"
                                ? "Dedike"
                                : "Dedike Entegrasyon"}
                        </span>
                    )}
                />
            </TableContainer>
        </>
    );
};

export default ResponsiveDataTable;
